import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Form } from "react-final-form";
import { Col, Row, Glyphicon, ButtonGroup, Button, ButtonToolbar, Tooltip, OverlayTrigger } from "react-bootstrap";
import DatePickerSura from "../../../general/componentes/DatePicker";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import NumericInput from "../../../general/componentes/NumericInput";
import EstadosGlosas from "./EstadosGlosas";
import TiposTransacciones from "../../../general/componentes/TiposTransacciones";
import TiposGestion from "./TiposGestion";
import TablaGlosas from "./TablaGlosas";
import { GlosaEmpleador, FiltroGlosasEmpleador, GestionGlosasMasivo } from "../modelo/GlosaEmpleador";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import { consultarGlosas, gestionarGlosas, gestionarMasivoGlosas, iniciarGestionGlosas, obtenerXLSDatosGlosas } from "../modulos/bandejaGlosasActions";
import UenActivas from "../../../general/componentes/UenActivas";
import { consultarMaestroUen, consultarMaestroTransaccionesSat, consultarCatalogoGlosasSat } from "../../../general/modulos/maestrosActions";
import { TransaccionSat } from "../../../general/modelo/TransaccionSat";
import ModalXLSDatosGlosas from "./ModalXLSDatosGlosas";
import TextoInput from "../../../general/componentes/TextoInput";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import CanalesIngreso from "../../../general/componentes/CanalesIngreso";
import { ModalGestionGlosas } from "./ModalGestionGlosas";
import { TiposProcesosGestion } from "../modelo/TiposProcesosGestion";
import { EstadoGlosa } from "../modelo/EstadosGlosa";
import { OrdenamientoGlosas } from "../modelo/OrdenamientoGlosas";
import FuenteEstadoPoliza from "./FuenteEstadoPoliza";
import { EstadoPolizaAfiliacion as estadoPolizaAfiliacion } from "../modelo/EstadoPolizaAfiliacion";
import { EstadoPolizaNovedad as estadoPolizaNovedad } from "../modelo/EstadoPolizaNovedad";

class BandejaGlosas extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.retornarListaGestionGlosas = this.retornarListaGestionGlosas.bind(this);
        this.obtenerNombreTipoTransaccion = this.obtenerNombreTipoTransaccion.bind(this);
        this.generarXLS = this.generarXLS.bind(this);
        this.estadoMasivoActivo = this.estadoMasivoActivo.bind(this);
        this.totalGlosasGestion = this.totalGlosasGestion.bind(this);
        this.obtenerMensajeAction = this.obtenerMensajeAction.bind(this);
        this.renderTooltipEstadoPoliza = this.renderTooltipEstadoPoliza.bind(this);

        this.state = {
            listaSeleccionGlosas: [],
            showModalXLS: false,
            showModalGestionGlosa: false,
            maxRegistrosXLS: 10000,
            observacionGestion: '',
            masivosActivo: false,
            ordenamientoGlosas: undefined
        };
    }

    componentWillMount() {
        if (!this.props.transaccionesSat || this.props.transaccionesSat.length === 0) {
            this.props.dispatch(consultarMaestroTransaccionesSat());
        }
    }

    componentDidMount() {
        this.props.dispatch(consultarMaestroUen());
        if (!this.props.uenActivas) {
            this.props.dispatch(consultarMaestroUen());
        }

        this.props.dispatch(consultarCatalogoGlosasSat());
        if (!this.props.catalogoGlosasSat) {
            this.props.dispatch(consultarCatalogoGlosasSat());
        }
        if (this.props.tipoServicioConsulta) {
            this.setState({ tipoTransaccion: this.props.tipoServicioConsulta });
        }
    }

    render() {
        const { estado, estadoXLS, glosasEmpleador, tamanoPagina, paginaActual, paginas } = this.props;
        const { listaSeleccionGlosas, masivosActivo } = this.state;

        const tooltipEstado = (
            <Tooltip id="tooltip" className="tooltip-pos">
                <span className="tooltip-font">
                    <strong>PENDIENTE:</strong> Glosas reportadas por SAT que están pendientes por gestión
                    <br />
                    <strong>ANULADO:</strong> Glosas que no se pudieron gestionar por SURA
                    <br />
                    <strong>GESTIONAR:</strong> Glosas marcadas que se encuentran en proceso de gestión
                    <br />
                    <strong>SOLUCIONADO:</strong> Novedades que se enviaron a SAT exitosamente
                    <br />
                    <strong>NOTIFICACION_FUTURA:</strong> Novedades sin glosas, que se enviarán a futuro a SAT
                    <br />
                    <strong>PROCESANDO:</strong> Glosas gestionadas y están en proceso de envío a SAT
                    <br />
                    <strong>INVALIDO:</strong> Glosas que no se pudieron gestionar por error técnico o de negocio
                </span>
            </Tooltip>
        );

        const tooltipCodigoGlosa = (
            <Tooltip id="tooltip">
                <span className="tooltip-font">Ingrese el código de la glosa que vas a gestionar y dé Clic sobre uno de los resultados</span>
            </Tooltip>
        );

        const tooltipTipoGestion = (
            <Tooltip id="tooltip" className="tooltip-pos">
                <span className="tooltip-font">
                    <strong>SURA:</strong> Glosas que únicamente pueden ser gestionadas por SURA
                    <br />
                    <strong>EMPRESA:</strong> Glosas que pueden gestionar las empresas desde los <br />servicios transaccionales
                </span>
            </Tooltip>
        );

        const tooltipSeleccion = (
            <Tooltip id="tooltip">
                <span className="tooltip-font">Clic en la opción 'Selecciona' para buscar todos</span>
            </Tooltip>
        );

        const tooltipPeriodo = (
            <Tooltip id="tooltip">
                <span className="tooltip-font">Ingrese el periodo a consultar en el formato añomes.
                    <br />
                    <strong>Ejemplo: </strong> 201901
                </span>
            </Tooltip>
        );

        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Bandeja Inconsistencias SAT</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar novedades glosadas</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento Empleador</label>
                                                <TipoIdentificacion name="tipoDocumento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento Empleador</label>
                                                <NumericInput name="documento" placeholder="Ingrese un documento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Tipo de Transacción</label>
                                                <OverlayTrigger placement="top" overlay={tooltipSeleccion}>
                                                    <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                                                </OverlayTrigger>
                                                <TiposTransacciones name={"tipoTransaccion"} gestionables />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Estado</label>
                                                <OverlayTrigger placement="top" overlay={tooltipEstado}>
                                                    <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                                                </OverlayTrigger>
                                                <EstadosGlosas name={"estado"} />
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label>UEN</label>
                                                <OverlayTrigger placement="top" overlay={tooltipSeleccion}>
                                                    <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                                                </OverlayTrigger>
                                                <UenActivas name={"uen"} />
                                            </Col>
                                            {
                                                this.renderTooltipEstadoPoliza(Number(values.tipoTransaccion))
                                            }
                                            <Col sm={3}>
                                                <label>Fecha Inicial de Operación</label>
                                                <DatePickerSura name={"fechaInicial"} />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Final de Operación</label>
                                                <DatePickerSura name={"fechaFinal"} />
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumentoUsuario">Tipo Documento Usuario</label>
                                                <TipoIdentificacion name="tipoDocumentoUsuario" excluir={["NI"]} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documentoUsuario">Documento Usuario</label>
                                                <NumericInput name="documentoUsuario" placeholder="Ingrese un documento" />
                                            </Col>
                                            <Col sm={2}>
                                                <label>Tipo Gestión</label>
                                                <OverlayTrigger placement="top" overlay={tooltipTipoGestion}>
                                                    <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                                                </OverlayTrigger>
                                                <TiposGestion name={"tipoGestion"} />
                                            </Col>
                                            <Col sm={2}>
                                                <label>Código Glosa</label>
                                                <OverlayTrigger placement="top" overlay={tooltipCodigoGlosa}>
                                                    <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                                                </OverlayTrigger>
                                                <TextoInputSelector name="codigoGlosa" maestro={this.listaCatalogoGlosasSat()} />
                                            </Col>
                                            {
                                                (Number(values.tipoTransaccion) === 1 || Number(values.tipoTransaccion) === 4) &&
                                                <Col sm={2}>
                                                    <label>Canal Ingreso</label>
                                                    <CanalesIngreso name={"canalIngreso"} />
                                                </Col>
                                            }
                                            {
                                                (Number(values.tipoTransaccion) !== 1 && Number(values.tipoTransaccion) !== 4) &&
                                                <Col sm={2}>
                                                    <label>Fuente Ingreso</label>
                                                    <TextoInput name="fuenteIngreso" placeholder="Ingrese código" maxLength={6} />
                                                </Col>
                                            }
                                        </Row>
                                        <Row className={"form-group"}>
                                            {
                                                (Number(values.tipoTransaccion) === 12) &&
                                                <div>
                                                    <Col sm={2}>
                                                        <label>Periodo Inicio</label>
                                                        <OverlayTrigger placement="top" overlay={tooltipPeriodo}>
                                                            <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                                                        </OverlayTrigger>
                                                        <TextoInput name="periodoInicio" placeholder="Ingrese Periodo" maxLength={6} />
                                                    </Col>
                                                    <Col sm={2}>
                                                        <label>Periodo Fin</label>
                                                        <OverlayTrigger placement="top" overlay={tooltipPeriodo}>
                                                            <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                                                        </OverlayTrigger>
                                                        <TextoInput name="periodoFin" placeholder="Ingrese Periodo" maxLength={6} />
                                                    </Col>
                                                </div>
                                            }
                                        </Row>
                                        <div style={{ marginTop: `50px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {
                                                        (glosasEmpleador.length > 0) &&
                                                        <a className="btns btn-success" onClick={this.obtenerXLS}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                    {this.state.showModalXLS && this.mostrarModalXLS()}
                                                </Col>
                                                <Col sm={5}>
                                                    {
                                                        this.esEstadoSolucionado() ?
                                                            this.condicionMostrarBotonJerarquia(listaSeleccionGlosas, masivosActivo, glosasEmpleador)
                                                            && this.renderBotonJerarquia() :
                                                            this.condicionMostrarBotonesGestion(listaSeleccionGlosas, masivosActivo, glosasEmpleador)
                                                            && this.renderBotonesGestionGlosas()
                                                    }
                                                    {this.state.showModalGestionGlosa && this.renderModalGestionGlosas()}
                                                </Col>
                                                <Col smOffset={1} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderXLS(estadoXLS)}
                    {this.renderTablaGlosas(glosasEmpleador, estado, paginas, tamanoPagina, paginaActual)}
                </Row>
            </div>
        );
    }

    renderXLS = (estado: REQUEST) => {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error generando el XLS"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                        <label>Generando el reporte de inconsistencias...</label>
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"} mensaje={"Reporte de inconsistencias del SAT generado exitosamente"} />
                    </span>
                );
            default:
                return false;
        }
    };

    renderTablaGlosas(glosasEmpleador: Array<GlosaEmpleador>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!glosasEmpleador || !glosasEmpleador.length)
                    return (
                        <span>
                            <Mensaje type={"danger"} mensaje={"No se han encontrado inconsistencias"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaGlosas
                                glosasEmpleador={glosasEmpleador}
                                estado={this.props.estadoGestionGlosas}
                                filtroGlosasEmpleador={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                listaRespuestaGestionGlosas={this.props.listaRespuestaGestionGlosas}
                                transaccionesSat={this.props.transaccionesSat}
                                dniUsuarioGestionLogin={this.props.dniUsuarioGestionLogin}
                                errorMasivoGlosas={this.props.errorMasivoGlosas}
                                mensajeAction={this.props.mensajeAction}
                                ordenamientoGlosas={this.ordenamientoGlosas()}
                                esAfiliacionTraslado={this.transaccionEsAfiliacionTraslado()}
                                esReporteMora={this.transaccionEsReporteMora()}
                                seleccionGlosasGestion={this.handleSeleccionGlosasGestion}
                                retornarListaGestionGlosas={this.retornarListaGestionGlosas}
                                consultaPaginada={this.consultaPaginada}
                                obtenerNombreTipoTransaccion={this.obtenerNombreTipoTransaccion}
                                configActivarMasivoGlosas={this.configActivarMasivoGlosas}
                                estadoMasivoActivo={this.estadoMasivoActivo}
                                validarEstadoGestionGlosasActivo={this.validarEstadoGestionGlosasActivo}
                                estadoSolucionado={this.esEstadoSolucionado}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    esEstadoSolucionado = () => {
        return this.state.estado && this.state.estado === EstadoGlosa.solucionado;
    }

    condicionMostrarBotonJerarquia = (listaSeleccionGlosas: Array<any>, masivosActivo: boolean, glosasEmpleador: Array<GlosaEmpleador>) => {
        return listaSeleccionGlosas.length > 0 || (masivosActivo && glosasEmpleador.length > 0 && this.validarEstadoSolucionado(this.state.estado));
    }

    condicionMostrarBotonesGestion = (listaSeleccionGlosas: Array<any>, masivosActivo: boolean, glosasEmpleador: Array<GlosaEmpleador>) => {
        return listaSeleccionGlosas.length > 0 || (masivosActivo && glosasEmpleador.length > 0 && this.validarEstadoGestionGlosasActivo(this.state.estado));
    }

    renderTooltipEstadoPoliza(tipoTransaccion: number) {
        if (tipoTransaccion === 1 || tipoTransaccion === 4) {
            const tooltipEstadoPolizaAfiliacion = (
                <Tooltip id="tooltip" className="tooltip-pos">
                    <span className="tooltip-font">
                        <strong>ACTIVA:</strong> La póliza  se encuentra activa
                        <br />
                        <strong>NO APLICA:</strong> No se encuentra una póliza<br /> para el tipo y numero de documento
                    </span>
                </Tooltip>
            );

            return (
                <Col sm={3}>
                    <label>Estado Poliza</label>
                    <OverlayTrigger placement="top" overlay={tooltipEstadoPolizaAfiliacion}>
                        <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                    </OverlayTrigger>
                    <FuenteEstadoPoliza name={"estadoPolizaAfiliacion"} fuenteEstadoPoliza={estadoPolizaAfiliacion} />
                </Col>
            );
        }

        const tooltipEstadoPolizaNovedad = (
            <Tooltip id="tooltip" className="tooltip-pos">
                <span className="tooltip-font">
                    <strong>ACTIVA:</strong> La póliza  se encuentra activa
                    <br />
                    <strong>RETIRADA:</strong> No se encuentra una póliza activa
                </span>
            </Tooltip>
        );

        return (
            <Col sm={3}>
                <label>Estado Poliza</label>
                <OverlayTrigger placement="top" overlay={tooltipEstadoPolizaNovedad}>
                    <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                </OverlayTrigger>
                <FuenteEstadoPoliza name={"estadoPolizaNovedad"} fuenteEstadoPoliza={estadoPolizaNovedad} />
            </Col>
        );
    }

    renderBotonJerarquia() {
        const tooltipJerarquia = (
            <Tooltip id="tooltip" className="tooltip-pos">
                <span className="tooltip-font">
                    <strong>PROCESAR JERARQUIA:</strong> Se usa para reprocesar mensajes que dependen del envió exitoso de los mensajes seleccionados
                </span>
            </Tooltip>
        );

        return (
            <div className="button-group-form">
                <ButtonToolbar className="button-group-toolbar">
                    <ButtonGroup>
                        <Button bsStyle="primary"
                            className="btns-custom btns-primary"
                            onClick={() => this.setState({ showModalGestionGlosa: true, gestionGlosa: TiposProcesosGestion[5].codigoProceso })}>
                            <Glyphicon glyph="refresh" /> &nbsp;Procesar Jerarquia
                        </Button>
                    </ButtonGroup>
                    <OverlayTrigger placement="top" overlay={tooltipJerarquia}>
                        <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                    </OverlayTrigger>
                </ButtonToolbar>
            </div>
        );
    }

    renderBotonesGestionGlosas() {
        const tooltipGestiones = (
            <Tooltip id="tooltip" className="tooltip-pos">
                <span className="tooltip-font">
                    <strong>ANULAR:</strong> Se usa para marcar las glosas que no se pudieron gestionar por SURA
                    <br />
                    <strong>GESTIONAR:</strong> Glosas que se estarán analizando y que más tarde se enviarán a procesar a SAT
                    <br />
                    {
                        !this.transaccionEsAfiliacionTraslado() &&
                        <span>
                            <strong>REENVIAR:</strong> Se reenvía a SAT el mensaje original. Se usa cuando NO se modifica la información original
                            <br />
                        </span>
                    }
                    <strong>REPROCESAR:</strong> Se envía un nuevo mensaje a SAT. Se usa SI se realizó alguna actualización de datos
                    <br />
                    {
                        this.transaccionEsAfiliacion() &&
                        <span>
                            <strong>ENVIAR COMO TRASLADO:</strong> Se reenvía a SAT el mensaje original como un traslado. Esta opción solo se debe utilizar para las glosas bloqueantes
                            <br />
                        </span>
                    }
                    {
                        this.transaccionEsTraslado() &&
                        <span>
                            <strong>CAMBIAR FECHA CARTA:</strong> Se reenvía a SAT el mensaje original con la fecha seleccionada como fecha de carta.
                            <br />
                        </span>
                    }
                </span>
            </Tooltip>
        );
        return (
            <div className="button-group-form">
                <ButtonToolbar className="button-group-toolbar">
                    <ButtonGroup>
                        <Button bsStyle="primary"
                            className="btns-custom btns-primary"
                            onClick={() => this.setState({ showModalGestionGlosa: true, gestionGlosa: TiposProcesosGestion[0].codigoProceso })}>
                            <Glyphicon glyph="remove" /> &nbsp;Anular
                        </Button>
                        <Button bsStyle="primary"
                            className="btns-custom btns-primary"
                            onClick={() => this.setState({ showModalGestionGlosa: true, gestionGlosa: TiposProcesosGestion[1].codigoProceso })}>
                            <Glyphicon glyph="ok" /> &nbsp;Gestionar
                        </Button>
                        {
                            !this.transaccionEsAfiliacionTraslado() &&
                            <Button bsStyle="primary"
                                className="btns-custom btns-primary"
                                onClick={() => this.setState({ showModalGestionGlosa: true, gestionGlosa: TiposProcesosGestion[2].codigoProceso })}>
                                <Glyphicon glyph="refresh" /> &nbsp;Reenviar
                            </Button>
                        }
                        {
                            this.transaccionEsAfiliacion() &&
                            <Button bsStyle="primary"
                                className="btns-custom btns-primary"
                                onClick={() => this.setState({ showModalGestionGlosa: true, gestionGlosa: TiposProcesosGestion[4].codigoProceso })}>
                                <Glyphicon glyph="refresh" /> &nbsp;Enviar como Traslado
                            </Button>
                        }
                        {
                            this.transaccionEsTraslado() &&
                            <Button bsStyle="primary"
                                className="btns-custom btns-primary"
                                onClick={() => this.setState({ showModalGestionGlosa: true, gestionGlosa: TiposProcesosGestion[4].codigoProceso })}>
                                <Glyphicon glyph="refresh" /> &nbsp;Cambiar Fecha Carta
                            </Button>
                        }
                        <Button bsStyle="primary"
                            className="btns-custom btns-primary"
                            onClick={() => this.setState({ showModalGestionGlosa: true, gestionGlosa: TiposProcesosGestion[3].codigoProceso })}>
                            <Glyphicon glyph="pencil" /> &nbsp;Reprocesar
                        </Button>
                    </ButtonGroup>
                    <OverlayTrigger placement="top" overlay={tooltipGestiones}>
                        <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
                    </OverlayTrigger>
                </ButtonToolbar>
            </div>
        );
    }

    renderModalGestionGlosas() {
        return (
            <ModalGestionGlosas
                listaSeleccionGlosas={this.retornarListaGestionGlosas()}
                codigoProceso={this.state.gestionGlosa}
                cerrarModal={this.handleCloseModalGestionGlosa}
                gestionarGlosas={this.gestionarGlosas}
                estadoMasivoActivo={this.estadoMasivoActivo}
                procesarJerarquia={this.procesarJerarquia}
            />
        );
    }

    retornarListaGestionGlosas() {
        return this.state.listaSeleccionGlosas;
    }

    handleCloseModalGestionGlosa = () => {
        this.setState({ showModalGestionGlosa: false });
    };

    handleSeleccionGlosasGestion = (listaSeleccionGlosas: Array<GlosaEmpleador>) => {
        this.setState({ listaSeleccionGlosas: listaSeleccionGlosas });
    };

    validate = (values: any) => {
        const errors = {
            documento: undefined,
            tipoDocumento: undefined,
            fechaInicial: undefined,
            fechaFinal: undefined,
            canalIngreso: undefined,
            tipoDocumentoUsuario: undefined,
            documentoUsuario: undefined,
            periodoInicio: undefined,
            periodoFin: undefined
        };

        if (values.tipoDocumento && !values.documento)
            errors.documento = "Por favor ingrese un documento";

        if ((!values.tipoDocumento || values.tipoDocumento === "Selecciona...") && values.documento)
            errors.tipoDocumento = "Por favor seleccione un tipo de documento";

        if (values.tipoDocumentoUsuario && !values.documentoUsuario)
            errors.documentoUsuario = "Por favor ingrese un documento";

        if ((!values.tipoDocumentoUsuario || values.tipoDocumentoUsuario === "Selecciona...") && values.documentoUsuario)
            errors.tipoDocumentoUsuario = "Por favor seleccione un tipo de documento";

        if (values.fechaInicial && !values.fechaFinal)
            errors.fechaFinal = "Por favor selecciona una fecha de fin";

        if (!values.fechaInicial && values.fechaFinal)
            errors.fechaInicial = "Por favor selecciona una fecha de inicio";

        if (values.fechaInicial && values.fechaFinal && (values.fechaInicial.isAfter(values.fechaFinal)))
            errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";

        if (!values.fechaInicial && !values.fechaFinal)
            errors.fechaInicial = "Por favor seleccione una fecha como filtro para continuar";

        if (Number(values.tipoTransaccion) === 12) {
            if (values.periodoInicio && !this.textoPeriodoCumple(values.periodoInicio))
                errors.periodoInicio = "El texto del periodo no cumple con el formato.";

            if (values.periodoFin && !this.textoPeriodoCumple(values.periodoFin))
                errors.periodoFin = "El texto del periodo no cumple con el formato.";

            if (values.periodoInicio && values.periodoFin && !this.cumpleRangoPeriodo(values))
                errors.periodoFin = "El periodo final no puede ser superior al inicial.";
        }

        return errors;
    };

    onSubmit = (values: any) => {

        const dni = (values.tipoDocumento && values.documento) ? (values.tipoDocumento + values.documento) : undefined;
        const tipoTransaccion = values.tipoTransaccion ? Number(values.tipoTransaccion) : undefined;
        const estado = values.estado ? values.estado.valueOf() : undefined;
        const uen = values.uen ? values.uen.valueOf() : "";
        const tipoGestion = values.tipoGestion ? values.tipoGestion.valueOf() : "";
        const usuario = (values.tipoDocumentoUsuario && values.documentoUsuario) ? (values.tipoDocumentoUsuario + values.documentoUsuario) : undefined;
        const canal = (values.canalIngreso && (tipoTransaccion === 1 || tipoTransaccion === 4)) ? values.canalIngreso.valueOf() : "";
        const codigoGlosa = values.codigoGlosa ? values.codigoGlosa.value : undefined;
        const fechaInicial = values.fechaInicial ? values.fechaInicial.valueOf() : "";
        const fechaFinal = values.fechaFinal ? values.fechaFinal.valueOf() : "";

        const esAfiliacionTraslado = tipoTransaccion === 1 || tipoTransaccion === 4;
        const esTransaccionMora = tipoTransaccion === 12;

        const fuenteIngreso = () => {
            if (esAfiliacionTraslado) return canal;
            else return (values.fuenteIngreso ? values.fuenteIngreso.valueOf() : "");
        };

        const estadoPoliza = () => {
            if (esAfiliacionTraslado) return values.estadoPolizaAfiliacion ? values.estadoPolizaAfiliacion.valueOf() : "";
            else return values.estadoPolizaNovedad ? values.estadoPolizaNovedad.valueOf() : "";
        };

        const periodoInicio = esTransaccionMora && values.periodoInicio ? values.periodoInicio : undefined;
        const periodoFin = esTransaccionMora && values.periodoFin ? values.periodoFin : undefined;

        const filtroGlosasEmpleador: FiltroGlosasEmpleador = {
            dni: dni,
            tipoTransaccion: tipoTransaccion,
            estado: estado,
            uen: uen,
            tipoGestion: tipoGestion,
            usuario: usuario,
            fuenteIngreso: fuenteIngreso(),
            estadoPoliza: estadoPoliza(),
            codigoGlosa: codigoGlosa,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            periodoInicio: periodoInicio,
            periodoFin: periodoFin,
            registrosPorPagina: this.props.tamanoPagina,
            pagina: 0
        };

        this.setState(
            {
                listaSeleccionGlosas: [],
                masivosActivo: false,
                dni: dni,
                tipoTransaccion: tipoTransaccion,
                estado: estado,
                uen: uen,
                tipoGestion: tipoGestion,
                usuario: usuario,
                fuenteIngreso: fuenteIngreso(),
                estadoPoliza: estadoPoliza(),
                codigoGlosa: codigoGlosa,
                fechaInicial: fechaInicial,
                fechaFinal: fechaFinal,
                periodoInicio: periodoInicio,
                periodoFin: periodoFin,
                ordenamientoGlosas: undefined
            }
        );

        this.props.dispatch(consultarGlosas(filtroGlosasEmpleador, undefined));
    };

    filtros(): FiltroGlosasEmpleador {
        return {
            dni: this.state.dni,
            tipoTransaccion: this.state.tipoTransaccion,
            estado: this.state.estado,
            uen: this.state.uen,
            tipoGestion: this.state.tipoGestion,
            usuario: this.state.usuario,
            fuenteIngreso: this.state.fuenteIngreso,
            estadoPoliza: this.state.estadoPoliza,
            codigoGlosa: this.state.codigoGlosa,
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            periodoInicio: this.state.periodoInicio,
            periodoFin: this.state.periodoFin
        };
    }

    ordenamientoGlosas(): OrdenamientoGlosas {
        return this.state.ordenamientoGlosas;
    }

    procesarJerarquia = () => {
        console.log("seleccionados", this.state.listaSeleccionGlosas);
    }

    gestionarGlosas = (codigoProceso: number, observacion: string, fechaIngreso: any) => {
        const fechaEnvio = fechaIngreso.format("YYYY-MM-DD").valueOf();
        if (this.estadoMasivoActivo()) {
            const gestionGlosasMasivo: GestionGlosasMasivo = {
                filtroGlosasEmpleador: this.serializarFiltros(),
                datosGestionGlosas: {
                    codigoProceso: codigoProceso,
                    dniUsuarioOperacion: this.props.dniUsuarioGestionLogin,
                    observacion: observacion,
                    fechaEnvio: fechaEnvio
                }
            };
            this.props.dispatch(gestionarMasivoGlosas(gestionGlosasMasivo));
            this.setState({ listaSeleccionGlosas: [], masivosActivo: false });
        } else {
            if (this.state.listaSeleccionGlosas) {
                const selecciones = this.state.listaSeleccionGlosas.length;
                if (selecciones > 0) {
                    const dniLogin = this.props.dniUsuarioGestionLogin;
                    this.props.dispatch(iniciarGestionGlosas(selecciones));
                    this.state.listaSeleccionGlosas.forEach((glosasEmpleador: GlosaEmpleador, i: number) => {
                        if (this.props.estadoGestionGlosas !== REQUEST.FORBIDDEN) {
                            this.props.dispatch(gestionarGlosas(glosasEmpleador, i + 1, selecciones, codigoProceso, observacion, dniLogin, fechaEnvio));
                        }
                    });
                    this.setState({ listaSeleccionGlosas: [] });
                }
            }
        }
    };

    obtenerXLS = () => {
        const { totalGlosasConsulta } = this.props;
        if (totalGlosasConsulta < this.state.maxRegistrosXLS) {
            this.generarXLS(0);
        } else {
            this.setState({ showModalXLS: true });
        }
    };

    mostrarModalXLS() {
        const { totalGlosasConsulta } = this.props;
        const reportesXLS = Math.ceil(totalGlosasConsulta / this.state.maxRegistrosXLS);
        const totalPaginas = Math.ceil(totalGlosasConsulta / 10);
        return (
            <ModalXLSDatosGlosas
                totalGlosasConsulta={totalGlosasConsulta}
                reportesXLS={reportesXLS}
                totalPaginas={totalPaginas}
                showModalXLS={this.state.showModalXLS}
                closeModalXLS={() => this.handleCloseModalXLS()}
                generarXLS={this.generarXLS}
                maxRegistrosXLS={this.state.maxRegistrosXLS}
                tamanoPaginaFiltro={this.props.tamanoPagina}
            />
        );
    }

    generarXLS(reporte: number) {
        const filtroGlosasEmpleador = this.serializarFiltros();
        filtroGlosasEmpleador.pagina = reporte + 1;
        filtroGlosasEmpleador.registrosPorPagina = this.state.maxRegistrosXLS;
        this.setState({ listaSeleccionGlosas: [], showModalXLS: false });
        this.props.dispatch(obtenerXLSDatosGlosas(filtroGlosasEmpleador));
    }

    handleCloseModalXLS() {
        this.setState({ showModalXLS: false });
    }

    consultaPaginada = (filtroGlosasEmpleador: FiltroGlosasEmpleador, ordenamientoGlosas: OrdenamientoGlosas) => {
        this.setState({ listaSeleccionGlosas: [], ordenamientoGlosas: ordenamientoGlosas });
        this.props.dispatch(consultarGlosas(filtroGlosasEmpleador, ordenamientoGlosas));
    };

    obtenerNombreTipoTransaccion(codigo: number) {
        let busqueda = this.props.transaccionesSat.find((transaccion: TransaccionSat) => Number(transaccion.codigo) === codigo);
        return busqueda ? busqueda.nombre : "TRANSACCIÓN DESCONOCIDA";
    }

    transaccionEsAfiliacion() {
        const servicioTransaccion = Number(this.props.tipoServicioConsulta);
        return servicioTransaccion === 1;
    }

    transaccionEsTraslado() {
        const servicioTransaccion = Number(this.props.tipoServicioConsulta);
        return servicioTransaccion === 4;
    }

    transaccionEsAfiliacionTraslado() {
        const servicioTransaccion = Number(this.props.tipoServicioConsulta);
        return servicioTransaccion === 1 || servicioTransaccion === 4;
    }

    transaccionEsReporteMora() {
        const servicioTransaccion = Number(this.props.tipoServicioConsulta);
        return servicioTransaccion === 12;
    }

    configActivarMasivoGlosas = (activo: boolean) => {
        this.setState({ masivosActivo: activo });
    }

    estadoMasivoActivo() {
        return this.state.masivosActivo;
    }

    totalGlosasGestion() {
        if (this.state.masivosActivo) {
            if (this.props.totalGlosasConsulta > this.state.maxRegistrosXLS) {
                return this.state.maxRegistrosXLS;
            }
            return this.props.totalGlosasConsulta;
        } else {
            return this.retornarListaGestionGlosas().length;
        }
    }

    obtenerMensajeAction() {
        return this.props.mensajeAction;
    }

    serializarFiltros() {
        const filtros = this.filtros();
        filtros.pagina = 1;
        filtros.registrosPorPagina = (this.props.totalGlosasConsulta < this.state.maxRegistrosXLS + 1) ? this.props.totalGlosasConsulta : this.state.maxRegistrosXLS;
        filtros.estado = (filtros.estado ? filtros.estado : undefined);
        filtros.tipoGestion = (filtros.tipoGestion ? filtros.tipoGestion : undefined);
        filtros.estadoPoliza = (filtros.estadoPoliza ? filtros.estadoPoliza : undefined);
        filtros.fuenteIngreso = (filtros.fuenteIngreso ? filtros.fuenteIngreso : undefined);
        filtros.uen = (filtros.uen ? filtros.uen : undefined);
        return filtros;
    }

    validarEstadoGestionGlosasActivo = (estado: string) => {
        return ((estado === EstadoGlosa.gestionar || estado === EstadoGlosa.pendiente || estado === EstadoGlosa.invalido) || !estado);
    }

    validarEstadoSolucionado = (estado: string) => {
        return estado === EstadoGlosa.solucionado || !estado;
    }

    listaCatalogoGlosasSat = () => {
        if (this.props.catalogoGlosasSat && this.props.catalogoGlosasSat.length > 0) {
            return [{ value: '', label: 'TODO' }].concat(
                this.props.catalogoGlosasSat.map(value => ({
                    value: value.codigoGlosa,
                    label: value.codigoGlosa
                })
                ));
        }
        return [{ value: '', label: 'Cargando...' }];
    }

    textoPeriodoCumple = (periodo: any) => {
        const textoEsNumerico = texto => /^\d+$/.test(texto);
        const textoEsMesValido = texto => parseInt(texto.substr(4)) <= 12;

        return textoEsNumerico(periodo) && periodo.length === 6 && textoEsMesValido(periodo);
    };

    cumpleRangoPeriodo = (values: any) => {
        const anioInicio = parseInt(values.periodoInicio.substr(0, 4));
        const anioFin = parseInt(values.periodoFin.substr(0, 4));
        const mesInicio = parseInt(values.periodoInicio.substr(4));
        const mesFin = parseInt(values.periodoFin.substr(4));

        return ((anioInicio < anioFin) || (anioInicio === anioFin && mesInicio <= mesFin));
    };
}

export default connect((store: any) => {
    return {
        estado: R.pathOr([], ["inconsistencias", "estado"])(store),
        estadoGestionGlosas: R.pathOr([], ["inconsistencias", "estadoGestionGlosas"])(store),
        estadoXLS: R.pathOr([], ["inconsistencias", "estadoXLS"])(store),
        glosasEmpleador: R.pathOr([], ["inconsistencias", "glosasEmpleador"])(store),
        mensajeUsuario: R.pathOr(false, ["inconsistencias", "mensajeUsuario"])(store),
        tamanoPagina: R.pathOr([], ["inconsistencias", "tamanoPagina"])(store),
        paginaActual: R.pathOr([], ["inconsistencias", "paginaActual"])(store),
        paginas: R.pathOr([], ["inconsistencias", "paginas"])(store),
        totalGlosasConsulta: R.pathOr([], ["inconsistencias", "totalGlosasConsulta"])(store),
        tipoServicioConsulta: R.pathOr(undefined, ["inconsistencias", "tipoServicioConsulta"])(store),
        listaRespuestaGestionGlosas: R.pathOr([], ["inconsistencias", "listaRespuestaGestionGlosas"])(store),
        errorMasivoGlosas: R.pathOr(false, ["inconsistencias", "errorMasivoGlosas"])(store),
        mensajeAction: R.pathOr("", ["inconsistencias", "mensajeAction"])(store),
        transaccionesSat: R.pathOr([], ["maestros", "transaccionesSat"])(store),
        uenActivas: R.pathOr([], ["maestros", "uenActivas"])(store),
        catalogoGlosasSat: R.pathOr([], ["maestros", "catalogoGlosasSat"])(store),
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store)
    };
})(BandejaGlosas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/componentes/BandejaGlosas.tsx